import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdUnit } from '../../../../../../../models/adunit';
import { AdUnitService } from '../../../../../../../services/adunit.service';
import { Helpers } from '../../../../../../../helpers';
import { BaseComponent } from '../../../../base.component';
import { SelectService } from '../../../../../../../_services/select.service';
import { PublisherDetailTab } from '../../../../owner/publisher-detail/publisher-detail.component';
import { DataService } from '../../../../../../../_services/data.service';
import { Paths } from '../../../../../../../models/enums';

@Component({
    selector: 'app-adunit',
    templateUrl: './create-adunit.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CreateAdUnitComponent extends BaseComponent implements OnInit {
    returnUrl: any;
    adunit: AdUnit = new AdUnit();
    sizes: any[];
    siteId: string;
    pageId: string;
    publisherName: string;

    constructor(
        private adunitService: AdUnitService,
        private selectService: SelectService,
        private dataService: DataService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        super();
        this.siteId = route.snapshot.queryParams.siteId;
        this.pageId = route.snapshot.queryParams.pageId;
        this.returnUrl = route.snapshot.queryParams.returnUrl;
        if (!this.siteId || !this.pageId) this.router.navigate([this.returnUrl]);
        this.publisherName = route.snapshot.queryParams.publisherName;
        this.buildBreadcrumb(route);
    }

    buildBreadcrumb(route) {
        route.snapshot.parent.data.breadcrumb = route.snapshot.queryParams.pageName;
        route.snapshot.parent.data.queryParams = {
            siteId: this.siteId,
            pageId: this.pageId
        };
        route.snapshot.parent.data.url = '/' + route.snapshot.queryParams.returnUrl;
        route.snapshot.parent.parent.data.breadcrumb =
            route.snapshot.queryParams.siteName;
        route.snapshot.parent.parent.data.queryParams = { siteId: this.siteId };
        route.snapshot.parent.parent.data.url =
            '/' + route.snapshot.queryParams.returnUrl;
        route.snapshot.parent.parent.parent.data.url =
            '/' + route.snapshot.queryParams.returnUrl;
        if (this.dataService.path == Paths.Owner) {
            route.snapshot.parent.data.queryParams.tab = PublisherDetailTab.Inventory;
            route.snapshot.parent.parent.data.queryParams.tab =
                PublisherDetailTab.Inventory;
            route.snapshot.parent.data.queryParams.name = this.publisherName;
            route.snapshot.parent.parent.data.queryParams.name = this.publisherName;
            route.snapshot.parent.parent.parent.data.breadcrumb = this.publisherName;
        }
    }

    ngOnInit() {
        this.initSizeMultiSelect();
    }

    initSizeMultiSelect() {
        this.selectService.init({
            url: '/sizes/list',
            controlId: 'sizes',
            displayProperty: 'title',
            multiple: true
            // displayProperty: function(size){
            //     return size.width + "x" + size.height;
            // }
        });
    }

    navigate() {
        let queryParams = { siteId: this.siteId, pageId: this.pageId };
        if (this.dataService.path == Paths.Owner) {
            queryParams['tab'] = PublisherDetailTab.Inventory;
            queryParams['name'] = this.publisherName;
        }
        this.router.navigate([this.returnUrl], {
            queryParams: queryParams
        });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                title: customRules.requiredText
            }
        });
    }

    createAdUnit() {
        var _self = this;
        Helpers.setLoading(true);
        this.adunit.pageId = _self.pageId;
        this.adunitService.create(this.adunit).subscribe(res => {
            Helpers.setLoading(false);
            this.swalService.successCreate();
            this.adunit.title = '';
            setTimeout(function() {
                _self.navigate();
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/shared/inventory/adunit/create-adunit/create-adunit.component.ts